"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _pickReactKnownProp = require("pick-react-known-prop");

var _PaginationDot = _interopRequireDefault(require("./PaginationDot"));

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      position: 'absolute',
      bottom: theme.spacing(2),
      left: '50%',
      transform: 'translate(-50%, 0)',
      display: 'flex',
      flexDirection: 'row'
    }
  };
}, {
  name: 'SxJumbotronPagination'
});

function Pagination(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      dots = _ref.dots,
      index = _ref.index,
      onChangeIndex = _ref.onChangeIndex,
      pagintaionDotProps = _ref.pagintaionDotProps,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "dots", "index", "onChangeIndex", "pagintaionDotProps"]);
  var classes = useStyles();

  var handleClick = function handleClick(event, i) {
    onChangeIndex(i);
  };

  var children = [];

  for (var i = 0; i < dots; i += 1) {
    children.push(_react.default.createElement(_PaginationDot.default, (0, _extends2.default)({}, pagintaionDotProps, {
      key: i,
      index: i,
      active: i === index,
      onClick: handleClick
    })));
  }

  return _react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: classes.root
  }), children);
}

Pagination.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  dots: _propTypes.default.number.isRequired,
  index: _propTypes.default.number.isRequired,
  onChangeIndex: _propTypes.default.func.isRequired,
  pagintaionDotProps: _propTypes.default.shape({})
};
Pagination.defaultProps = {
  classes: undefined,
  className: undefined,
  pagintaionDotProps: undefined
};
var _default = Pagination;
exports.default = _default;